export default __webpack_public_path__ + "static/media/Aneomi-3.0c55a2ec.png";